import ExpandableTextController from "../expandable_text_component/expandable_text_component_controller";

export default class extends ExpandableTextController {};
